import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import LogoUrl from './../../assets/img/logo.svg';
import WiseLogo from './../../assets/img/wise.svg';

import SmartLink from "../../lib/includes/components/component.smartlink";
import Signup from "./component.signup";

const Footer = (props) => {
    if (!props.general) {
      return null;
    }

    let footer = props.general.footer;

    return  <footer className="site-footer">

        <div className="site-footer-content">

            <div className="site-footer-signup">
                <div className="container">
                    <div className="row">
                        <div className="col-lg mb-3 mb-lg-0">
                            <h2>Subscribe to our news and upcoming events</h2>
                        </div>
                        <div className="col-lg-4">
                            <Signup />
                        </div>
                    </div>
                </div>
            </div>

            <div className="site-footer-links">
                <div className="container">
                    <div className="row">
                        <div className="col-md col-logo me-auto">
                            <Link to="/" className="logo">
                                <img src={LogoUrl} alt={props.general.title}/>
                            </Link>
                            <a href="https://wise-materials.org/" target="_blank" className="logo-addon">
                                <img src={WiseLogo} alt="WISE"/>
                                <span>A Wise Industrial research arena</span>
                            </a>
                        </div>
                        {footer.columns.map((col, i) => {
                            return <div key={i} className="col-md-2">
                                <h3>{col.title}</h3>
                                <ul className="nav">
                                    {col.links.map((item, i) => {
                                        return <li key={i} className="nav-item">
                                            <SmartLink url={item.link.url} target={item.link.target} className="nav-link">{item.link.title}</SmartLink>
                                        </li>
                                    })}
                                </ul>
                            </div>
                        })}
                    </div>
                </div>
            </div>
        </div>

            {footer.logo_group &&
                <div className="logo-group logo-group-alt">
                    <div className="logo-group-track">

                        {footer.logo_group.map((item,i) => {
                            return <a href={item.url} key={i} target="_blank">
                                <img src={item.logo.url} alt={item.alt}/>
                            </a>
                        })}

                        {/*COPY*/}
                        {footer.logo_group.map((item,i) => {
                            return <a href={item.url} key={i} target="_blank">
                                <img src={item.logo.url} alt={item.alt}/>
                            </a>
                        })}
                    </div>
                </div>
            }


        </footer>

};

export default connect(
  state => {
    return {
      general: state.generalState.general
    }
  },
)(Footer);
